export default "__VITE_ASSET__DeSY1wFz__"